import {
  RecipientValidationFailureReason,
  RecipientValidationHoldings,
  RecipientValidationRequest,
} from '@interfaces';
import { CostBasisMethods, FlowTypes } from '@interfaces/models';
import { CostBasisPosition } from '@shared/services';
import { parseStrDefaultToZero } from '@sharedUtils';

/**
 * Receiving-account restriction reasons returned by the CO6 gifting validation
 * lambda.
 */
export const TO_ACCOUNT_RESTRICTION_REASONS: readonly RecipientValidationFailureReason[] = [
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_PVBA,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_MISC,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_CLRQ,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_RCLM,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_NOD,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_AMLT,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_CIP,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_FIP,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_CAND,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_ESCH,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_DIMC,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_FRAD,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_RPO,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_MVTA,
  RecipientValidationFailureReason.TO_ACCOUNT_RESTRICTIONS_ACTR,
];

export const hasToAccountRestriction = (
  failureReasons: RecipientValidationFailureReason[] = [],
): boolean => failureReasons.some((reason) => TO_ACCOUNT_RESTRICTION_REASONS.includes(reason));

export const buildGiftingRecipientValidationPayload = (
  toAccountNumber: string,
  toAccountName: string,
  positions: CostBasisPosition[],
  fromAccountNumber?: string,
): RecipientValidationRequest => {
  const holdings: RecipientValidationHoldings[] = positions.map((position) => ({
    cusip: position.cusip || '',
    symbol: position.ticker,
    amountIndicator: position.giftingMethod === 'DOLLAR_AMOUNT' ? 'DOLLARS' : 'SHARES',
    amount:
      typeof position.selectedAmount === 'number'
        ? position.selectedAmount
        : parseStrDefaultToZero(position.selectedAmount),
    settlementFund: !!position.settlementFund,
    costBasisMethod: position.selectedCostBasisMethod,
  }));
  return {
    toAccountNumber,
    toAccountName,
    ...(fromAccountNumber ? { fromAccountNumber } : {}),
    holdings,
    transactionType: FlowTypes.GIFTING,
  };
};
